import React from 'react'
import type { CompanyBranding } from '@/types/branding.types'
import { BpexCustomLanding } from '../custom/BpexCustomLanding'
import { VanguardCustomLanding } from '../custom/VanguardCustomLanding'

export interface CustomLandingPageProps {
  branding: CompanyBranding
  isWhiteLabel: boolean
  tenantSlug: string
  loginUrl: string
  contactEmail: string
  contactPhone: string | null
  onOpenDemoModal: () => void
}

export interface CustomLandingDescriptor {
  key: string
  name: string
  partnerName: string
  description: string
  component?: React.ComponentType<CustomLandingPageProps>
  supportedTokens: boolean
  version: string
}

/**
 * Catálogo de Landing Pages Customizadas desenvolvidas sob medida em arquivos físicos React.
 * Permite que cada parceiro tenha 100% de controle sobre o código, layout, copy, scripts e componentes.
 */
export const CUSTOM_LANDING_REGISTRY: Record<string, CustomLandingDescriptor> = {
  bpex_exclusive: {
    key: 'bpex_exclusive',
    name: 'BPEX Gestão Estratégica — Layout Sob Medida',
    partnerName: 'BPEX Consultoria',
    description: 'Apresentação exclusiva com foco em BPO financeiro, controladoria avançada e esteira de conciliação.',
    component: BpexCustomLanding,
    supportedTokens: true,
    version: '1.2.0',
  },
  vanguard_fintech: {
    key: 'vanguard_fintech',
    name: 'Vanguard Gestão — Layout Sob Medida',
    partnerName: 'Vanguard Capital',
    description: 'Multi-Family Office, inteligência de valuation, gestão de tesouraria e controladoria executiva BPO.',
    component: VanguardCustomLanding,
    supportedTokens: true,
    version: '2.0.0',
  },
}

export function getCustomLandingDescriptor(key: string | null | undefined): CustomLandingDescriptor | null {
  if (!key) return null
  return CUSTOM_LANDING_REGISTRY[key] || null
}

export function listAvailableCustomLandings(): CustomLandingDescriptor[] {
  return Object.values(CUSTOM_LANDING_REGISTRY)
}
